/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid } from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import { getEstadosAnteojoArreglo } from "../../services/VerAnteojoArregloService";
import DatosGestionAtencionCliente from "./DatosGestionAtencionCliente";
import DatosAnteojoArreglo from "./DatosAnteojoArreglo";
import DatosAccordion from "./DatosAccordion";
import WaitingDialog from "../../utils/WaitingDialog";
//
// ###########################################################################
//
const VerAnteojoArregloDialog = ({
  idGestionAtencion,
  anteojoArreglo,
  codigoAnteojoArreglo,
  idGcAnteojoArreglo,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [accordionExpanded, setAccordionExpanded] = useState(false);
  const [datosAccordionSummaryCargados, setDatosAccordionSummaryCargados] = useState(false);
  const [datosObtenidos, setDatosObtenidos] = useState(false);
  const [datosAnteojoArregloEstado, setDatosAnteojoArregloEstado] = useState([]);

  const tableColumns = [
    {
      field: "descripcion_corta_area",
      headerName: "Sucursal",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta_area;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "estado_short",
      headerName: "Estado",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado_short;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "accion_short",
      headerName: "Acción",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.accion_short;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cambio_articulo",
      headerName: "Cambio",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cambio_articulo ? "CAMBIO" : "";
        return _val;
      },
    },
    {
      field: "detalle",
      headerName: "Detalle",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.detalle;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "observaciones",
      headerName: "Observaciones",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.observaciones;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Fecha Estado",
      flex: 1,
      headerAlign: "center",
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "usuario_username",
      headerName: "Vendedor",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.usuario_username;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    const loadDatosAnteojoArreglo = async () => {
      setIsDoingSomething(true);
      const response = await getEstadosAnteojoArreglo(anteojoArreglo, idGcAnteojoArreglo);
      setIsDoingSomething(false);

      if (response.ok) {
        setDatosAnteojoArregloEstado(response.data.data);
        setDatosObtenidos(true);
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };

    loadDatosAnteojoArreglo();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (accordionExpanded && !datosAccordionSummaryCargados) {
      setDatosAccordionSummaryCargados(true);
    }
  }, [accordionExpanded]);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="xl"
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          VER {anteojoArreglo.toUpperCase()} {codigoAnteojoArreglo}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {datosObtenidos && (
          <>
            <DialogContent dividers>
              <Accordion
                sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}
                expanded={accordionExpanded}
                onChange={() => {
                  setAccordionExpanded(!accordionExpanded);
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <DatosAccordion idGestionAtencion={idGestionAtencion} />
                </AccordionSummary>
                <AccordionDetails>
                  {datosAccordionSummaryCargados && (
                    <>
                      {idGestionAtencion && (
                        <DatosGestionAtencionCliente idGestionAtencion={idGestionAtencion} />
                      )}

                      {anteojoArreglo && (
                        <>
                          <DatosAnteojoArreglo
                            anteojoArreglo={anteojoArreglo}
                            idGcAnteojoArreglo={idGcAnteojoArreglo}
                          />
                        </>
                      )}
                    </>
                  )}
                </AccordionDetails>
              </Accordion>

              <Box
                sx={{
                  border: "2px solid steelblue",
                  borderRadius: "5px",
                  p: 2,
                }}
              >
                <Grid container spacing={1} sx={{ mb: 1 }}>
                  <Grid item xs={12}>
                    <DataGrid
                      rows={datosAnteojoArregloEstado}
                      columns={tableColumns}
                      {...tableOptions}
                    />
                  </Grid>
                </Grid>
              </Box>
            </DialogContent>

            <DialogActions>
              <Box sx={{ textAlign: "right", p: 1 }}>
                <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
                  Cerrar
                </Button>
              </Box>
            </DialogActions>
          </>
        )}
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default VerAnteojoArregloDialog;
